// import Cookies from 'js-cookie';
import {
  CantonMgeSvr
} from '@/service/CantonMgeSvr';

// export let division = Cookies.get('division') ? Cookies.get('division') : getDivision();
export let division = sessionStorage.getItem('division') || getDivision();

function getDivision() {
  new CantonMgeSvr().GetCityCantonCode('').then(res => {
    division = res;
    return res;
  });
}



// export const dimension = 192;  //更改的分辨率
export const dimension = 1; //更改的分辨率
export const isShowMenu = true; //是否显示侧边栏(true开发环境显示，false 不显示)
export const devEnvironment ='api/'; //开发环境请求配置
// console.log('location.pathname', window.location.pathname);
export const proEnvironment = './'; //生产环境请求配置
export function baseUrl() {
  let baseURL = '';
  if (process.env.NODE_ENV === 'development') {
    baseURL = window.location.pathname + 'api/';
  } else if (process.env.NODE_ENV === 'production') {
    baseURL = 'szwyweb/';
  }
  return baseURL;
}